export enum SPREAD_STATUSES {
  PENDING = "PENDING",
  UPLOADING = "UPLOADING",
  PROCESSING = "PROCESSING",
  PENDING_REVIEW = "PENDING_REVIEW",
  PENDING_FINAL_REVIEW = "PENDING_FINAL_REVIEW",
  PUBLISHED = "PUBLISHED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  REVIEW_COMPLETED = "REVIEW_COMPLETED",
  PROCESSING_FAILED = "PROCESSING_FAILED",
  FINAL_REVIEW_COMPLETED = "FINAL_REVIEW_COMPLETED",
  REJECTED = "REJECTED"
}

export enum HUMAN_READABLE_FIXED_STATUSES {
  UPLOADING = "Uploading...",
  UPLOAD_FAILED = "Upload Failed",
  PROCESSING = "Processing...",
  COMPLETED = "Completed",
  MODEL_ERROR = "Model Error. Contact Moody's"
}

export enum SPREAD_COLUMNS {
  ENTITY_NAME = "ENTITY",
  TIME_PERIOD = "TIME PERIOD",
  LAST_EDITED_BY = "LAST VIEWED BY",
  LAST_EDITED = "LAST VIEWED",
  STATUS = "STATUS",
  TEMPLATE = "TEMPLATE",
  UPLOAD_TIME = "UPLOADED",
  UPLOADED_BY = "UPLOADED BY"
}

export interface SpreadSort {
  sortColumn: SPREAD_COLUMNS;
  sortAscending: boolean;
}

export interface Pagination {
  selected?: number;
}

export interface Search {
  query?: string;
}

export interface SpreadFilter {
  active?: boolean;
}

export interface SpreadStatusGroup {
  statusGroup?: string;
}

export interface Tab {
  activeTab: number;
}

export type BriefSpreadStatus = SPREAD_STATUSES;

export interface BriefSpread {
  spreadId: string;
  documentName: string;
  status: BriefSpreadStatus;
  uploadedByUser: string;
  timestamp: string;
  pdfUrl: string;
  pageCount: number;
  processedPages: number;
  modificationTime: string;
  modifiedByUser: string;
  modelTemplateType: string;
  modelTemplateVersion: string;
  locked: boolean;
  environmentName: string;
  lockedBy: string;
  rejected: boolean;
  priority: boolean;
  version: number;
  periodCount: number;
  timestampMillis: number;
  entityName: string;
  latestPeriod: string;
  commentsReadBy?: string[];
  isAccessible?: boolean;
  humanReadableStatus?: string;
  hasComments?: boolean;
}

export interface BriefSpreadResponse {
  briefSpreadModels: { briefSpreadModels: BriefSpread[] };
  briefSpreadCount: number;
}



// WEBPACK FOOTER //
// ./src/documentList/types.ts